import { Navigate, Route, RouteObject, Routes } from 'react-router-dom';

import { DefaultLayout2, GuardScope, useAccessGuard } from '@web/app/shared';

import { AgentCatalogPage, AgentCatalogSettingsPage, AgentChatPage, MyAgentChatPage, MyAgentsPage } from '../pages';

/**
 * Route paths constants separated by context
 */
export const AGENTS_ROUTE_PATHS = {
    ROOT: '/',
    DETAIL: ':id',
    CHAT: ':id/chats/:chatId',
} as const;

export const CATALOG_ROUTE_PATHS = {
    ROOT: '/',
    SETTINGS: ':id/settings',
    CHAT: ':id/chat',
} as const;

/**
 * My Agents routes component for /my-agents/* path
 * Handles user's own agents management
 */
export const MyAgentsRoutes = () => {
    // TODO: 추후 GuardScope.Project로 변경 예정
    useAccessGuard(GuardScope.Workspace);

    return (
        <Routes>
            <Route element={<DefaultLayout2 />}>
                <Route path={AGENTS_ROUTE_PATHS.ROOT} element={<MyAgentsPage />} />
                <Route path={AGENTS_ROUTE_PATHS.DETAIL} element={<MyAgentsPage />} />
                <Route path={AGENTS_ROUTE_PATHS.CHAT} element={<MyAgentChatPage />} />
                <Route path="*" element={<Navigate to="/my-agents" replace />} />
            </Route>
        </Routes>
    );
};

/**
 * Agent Catalog routes component for /agent-catalogs/* path
 * Handles public catalog and chat functionality
 */
export const AgentCatalogRoutes = () => {
    // TODO: 추후 GuardScope.Project로 변경 예정
    useAccessGuard(GuardScope.Workspace);

    return (
        <Routes>
            <Route element={<DefaultLayout2 />}>
                <Route path={CATALOG_ROUTE_PATHS.ROOT} element={<AgentCatalogPage />} />
                <Route path={CATALOG_ROUTE_PATHS.SETTINGS} element={<AgentCatalogSettingsPage />} />
                <Route path={CATALOG_ROUTE_PATHS.CHAT} element={<AgentChatPage />} />
                <Route path="*" element={<Navigate to="/agent-catalogs" replace />} />
            </Route>
        </Routes>
    );
};

/**
 * Route objects for external use with clear path mapping
 * These can be used for navigation or route generation
 */
export const agentRoutes: RouteObject[] = [
    // My Agents routes - User's own agents management
    {
        path: '/my-agents',
        element: <MyAgentsPage />,
    },
    {
        path: '/my-agents/:id',
        element: <MyAgentsPage />,
    },
    // Agent Catalog routes - Public catalog and chat functionality
    {
        path: '/agent-catalogs',
        element: <AgentCatalogPage />,
    },
    {
        path: '/agent-catalogs/:id/settings',
        element: <AgentCatalogSettingsPage />,
    },
    {
        path: '/agent-catalogs/:id/chat',
        element: <AgentChatPage />,
    },
];
